import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Tag query: ")
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "el-icon-close upper-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "tag-query",
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hover = true)),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hover = false))
  }, [
    _hoisted_1,
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(_ctx.name) + " | " + _toDisplayString(_ctx.getConditionName(_ctx.condition)) + " | " + _toDisplayString(_ctx.value) + " ", 1),
    (_ctx.hover)
      ? (_openBlock(), _createBlock("i", _hoisted_3))
      : _createCommentVNode("", true)
  ], 32))
}